<div class="container">
    <div class="video-content">
        <h3>How it Works?</h3>
        <a href="https://www.youtube.com/watch?v=wKCsprWTN70" class="video-btn popup-youtube"><i class="fas fa-play"></i></a>
    </div>
</div>